import { render, staticRenderFns } from "./StepConteudo.vue?vue&type=template&id=386b8992&scoped=true"
import script from "./StepConteudo.vue?vue&type=script&lang=js"
export * from "./StepConteudo.vue?vue&type=script&lang=js"
import style0 from "./StepConteudo.vue?vue&type=style&index=0&id=386b8992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b8992",
  null
  
)

export default component.exports